/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createGetMatrixDataType } from '../../factoriesAny.js';
export var getMatrixDataTypeDependencies = {
  typedDependencies,
  createGetMatrixDataType
};